
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"64","height":"64","viewBox":"0 0 64 64"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('radialGradient',{attrs:{"id":"16-a","cx":"46.588%","cy":"65.195%","r":"100%","fx":"46.588%","fy":"65.195%"}},[_c('stop',{attrs:{"offset":"0%","stop-color":"#FFD404"}}),_c('stop',{attrs:{"offset":"100%","stop-color":"#FFA204"}})])]),_c('g',{attrs:{"fill":"none","fill-rule":"evenodd"}},[_c('circle',{attrs:{"cx":"32","cy":"32","r":"24.5","fill":"#FFF","stroke":"#FFF","stroke-width":"3"}}),_c('circle',{attrs:{"cx":"32","cy":"32","r":"23","fill":"url(#16-a)"}}),_c('circle',{attrs:{"cx":"47","cy":"37","r":"5","fill":"#F95959"}}),_c('circle',{attrs:{"cx":"17","cy":"37","r":"5","fill":"#F95959"}}),_c('path',{attrs:{"fill":"#353741","d":"M32 48c5.606 0 9.95-2.435 13.03-7.306a.5.5 0 00-.67-.702C40.24 42.331 36.12 43.5 32 43.5c-4.12 0-8.24-1.17-12.36-3.508a.5.5 0 00-.67.703C22.05 45.565 26.394 48 32 48zm-7-19.048c3.75 0 5 4.762 5 2.381C30 28.953 28.75 23 25 23s-5 6.032-5 8.333c0 2.302 1.25-2.38 5-2.38zm14 0c3.75 0 5 4.762 5 2.381C44 28.953 42.75 23 39 23s-5 6.032-5 8.333c0 2.302 1.25-2.38 5-2.38z"}})])])
          )
        }
      }
    